// src/views/Messages.js
import React from 'react';

const Messages = () => {
  return <div>Messages Page</div>;
};

export default Messages;
